import { UserProfile } from "../../profile/profile.model";

export function isOpsAdminUser(
  profile: UserProfile | null | undefined,
): boolean {
  return profile?.role === "ADMIN";
}

/** Matches Treeslo main header profile display (header.component.ts). */
export function getProfileHeaderDisplay(
  profile: UserProfile | null | undefined,
): { initials: string; name: string; email: string } {
  if (!profile) {
    return { initials: "U", name: "User", email: "" };
  }

  const fullName = profile.name || profile.email || "";
  const names = fullName.trim().split(/\s+/);
  const initials = names
    .map((part) => part[0]?.toUpperCase())
    .join("")
    .slice(0, 2);

  return {
    initials: initials || profile.email?.charAt(0)?.toUpperCase() || "U",
    email: profile.email || "",
    name:
      fullName ||
      profile.email?.slice(0, profile.email.indexOf("@")) ||
      "User",
  };
}
